import { defineComponent, ref, useContext, useCssModule } from '@nuxtjs/composition-api';
import { useRecommendationSystem } from '~/composables/useRecommendationSystem';
import { RECOMMENDATION_ITEM_WIDTH } from '~/components/RecommendationArticles/index';
export default defineComponent({
    name: 'RecommendationArticles',
    props: {
        parentIndex: {
            default: 0,
            type: Number,
        },
    },
    setup(props) {
        const css = useCssModule();
        const context = useContext();
        const utm = `utm_source=forbes&utm_campaign=recommendation_system_new_${props.parentIndex + 1}`;
        const recommendation = useRecommendationSystem();
        const getArticlesTask = recommendation?.getArticlesTask;
        const isRunningArticlesTask = recommendation?.isRunningArticlesTask;
        const ym = context.$yandexMetrika;
        const shouldRender = ref(true);
        const articles = ref([]);
        async function handleIntersect({ observer }) {
            if (articles.value.length || isRunningArticlesTask.value) {
                return observer?.disconnect();
            }
            try {
                const data = await getArticlesTask?.perform();
                articles.value = data.map((article) => {
                    article.url_alias += article.url_alias?.includes('?') ? `&${utm}` : `?${utm}`;
                    return article;
                });
                shouldRender.value = !!articles.value.length;
            }
            catch (e) {
                shouldRender.value = false;
            }
            finally {
                observer?.disconnect();
            }
        }
        function sendMetrik({ observer }) {
            ym.reachGoal('recommend');
            return observer?.disconnect();
        }
        return {
            css,
            RECOMMENDATION_ITEM_WIDTH,
            shouldRender,
            articles,
            getArticlesTask,
            isRunningArticlesTask,
            handleIntersect,
            sendMetrik,
        };
    },
});
